import React from "react";
import { IconArchiveFilled } from "@tabler/icons-react";

export default function Archived({ requests }) {
  return (
    <div>
      {requests.length ? (
        <div className="mb-4 flex items-center gap-2 font-semibold text-mauve-600">
          <IconArchiveFilled className="size-4" />
          <span>Archived Requests</span>
        </div>
      ) : (
        <div className="mb-3 font-semibold text-mauve-600">
          No archived requests
        </div>
      )}

      {requests}
    </div>
  );
}
